/**
 * Paths used by `Send to Cart` feature. Allows in example conditionally redirection.
 */
export const MERCHANT_MENU_CATEGORY_PATHS = ['category'];
